function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2560 212.144c-16.757 0-2278.557 5.5-2278.557 5.5H165.29c-6.444 0-44.651 92.677-50.942 92.677s1.841-297.826-4.6-297.826-48.182 203.466-54.014 203.466H0",
  fill: "none",
  stroke: "rgba(9,191,255,0.6)",
  strokeMiterlimit: 10,
  strokeWidth: 25,
  opacity: 0.13
});

function SvgPulseLine4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2560.03,
    height: 322.826,
    viewBox: "0 0 2560.03 322.826"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYwLjAzIiBoZWlnaHQ9IjMyMi44MjYiIHZpZXdCb3g9IjAgMCAyNTYwLjAzIDMyMi44MjYiPjxwYXRoIGQ9Ik0zMTgyLjgzNCw3MDkuODk0Yy0xNi43NTcsMC0yMjc4LjU1Nyw1LjUtMjI3OC41NTcsNS41SDc4OC4xMjRjLTYuNDQ0LDAtNDQuNjUxLDkyLjY3Ny01MC45NDIsOTIuNjc3czEuODQxLTI5Ny44MjYtNC42LTI5Ny44MjZTNjg0LjQsNzEzLjcxMSw2NzguNTY4LDcxMy43MTFINjIyLjgzNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYyMi44MzQgLTQ5Ny43NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSg5LDE5MSwyNTUsMC42KSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjI1IiBvcGFjaXR5PSIwLjEzIi8+PC9zdmc+";
export { SvgPulseLine4 as ReactComponent };